export const portalConstants = {
    SET_PORTAL_SETTINGS: 'SET_PORTAL_SETTINGS',
    PORTAL_LOADING: 'PORTAL_LOADING',
    SET_IS_SUBMITTING: 'SET_IS_SUBMITTING',
    CLOUDFLARE_TURNSTILE: 'CLOUDFLARE_TURNSTILE',
    CLEAR_SITE_KEY: 'CLEAR_SITE_KEY',
    RESET_SITE_KEY: 'RESET_SITE_KEY',
};
